import React from "react";
import VisitorDashboard from "../../Components/VisitorDashboard";

const Dashboard = () => {
  return (
    <div>
      <VisitorDashboard />
    </div>
  );
};

export default Dashboard;
